// ── Firma de cuenta: texto plano o HTML ──────────────────────────────────────
// El campo de firma de cada cuenta IMAP (Ajustes → Cuentas) escapaba SIEMPRE
// el contenido, así que pegar una firma HTML producía `&lt;table&gt;` visible
// en el correo. Ahora se detecta cuál de las dos cosas es y se trata distinto.
//
// Por qué detección y no un interruptor "esto es HTML": las firmas de texto
// plano que ya existen siguen andando sin que nadie las toque. Un interruptor
// obliga a entrar cuenta por cuenta a marcarlo, y una cuenta que se olvide
// queda mandando etiquetas en crudo sin que nadie se entere hasta que lo ve un
// cliente.

// Una etiqueta de verdad: `<tag`, `<tag ...>`, `<tag/>` o `</tag>`.
//
// El nombre tiene que terminar en espacio, `>` o `/` — sin eso, una firma de
// texto plano que diga `Eduardo <eduardo@evo.com>` se leería como HTML, porque
// `<eduardo` parece una etiqueta hasta que aparece la arroba. Con el corte, la
// arroba descarta la coincidencia y la firma se sigue tratando como texto.
const HTML_TAG = /<[a-z][a-z0-9]*(?:\s[^>]*)?\/?>|<\/[a-z][a-z0-9]*\s*>/i;

export function isHtmlSignature(sig: string): boolean {
  return HTML_TAG.test(sig);
}

function escapeHtml(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

/**
 * La firma tal como sale EN EL CORREO.
 *
 * HTML → se inserta crudo, sin envoltorio: quien escribió una firma con tablas
 * ya decidió cómo se separa del cuerpo, y meterle un `--` y un borde encima le
 * arruina el diseño.
 *
 * Texto plano → el formato de siempre: `-- `, una línea por renglón.
 *
 * Los colores van en hexadecimal literal a propósito. Antes eran
 * `var(--evo-stroke)` y `var(--evo-fg-3)`, tokens del tema de la app: existen
 * en Evo Hub y en ningún cliente de correo. La línea separadora nunca se vio
 * en ningún correo enviado, y el gris del texto tampoco. Un token de diseño no
 * cruza la frontera del envío.
 */
export function buildSigHtml(sig: string): string {
  if (!sig.trim()) return '';
  if (isHtmlSignature(sig)) return sig;

  const lines = sig
    .split('\n')
    .map(l => `<p style="margin:0">${escapeHtml(l) || '<br>'}</p>`)
    .join('');
  return (
    '<div style="margin-top:12px;padding-top:8px;border-top:1px solid #dddddd;' +
    'color:#777777;font-size:12px">' +
    '<p style="margin:0">-- </p>' +
    lines +
    '</div>'
  );
}
